<div class="sf-search-select" [class.open]="isOpen" [class.is-disabled]="disabled">
  <button
    type="button"
    class="sf-search-select__btn"
    role="combobox"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="(testId || 'search-select') + '-listbox'"
    [disabled]="disabled"
    [attr.data-testid]="testId || null"
    (click)="toggle()"
  >
    <span *ngIf="selectedOption; else placeholderTpl">{{ selectedOption?.label }}</span>
    <ng-template #placeholderTpl>
      <span class="ph">{{ placeholder }}</span>
    </ng-template>
    <i>▾</i>
  </button>

  <div class="sf-search-select__pop" *ngIf="isOpen" [ngStyle]="popStyle">
    <div class="sf-search-select__search">
      <i aria-hidden="true">
        <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <circle cx="7" cy="7" r="5"></circle>
          <path d="m11 11 3.5 3.5"></path>
        </svg>
      </i>
      <input
        #searchInput
        type="text"
        [placeholder]="searchPlaceholder"
        [(ngModel)]="search"
        (input)="onSearchInput()"
        (keydown)="onKeydown($event)"
        (click)="$event.stopPropagation()"
        [attr.aria-activedescendant]="filteredOptions[activeIndex] ? optionId(filteredOptions[activeIndex]) : null"
        [attr.data-testid]="testId ? testId + '-search' : null"
      />
    </div>

    <div class="sf-search-select__empty" *ngIf="loading">Carregando…</div>

    <ng-container *ngIf="!loading">
      <ul class="sf-search-select__list" [style.max-height.px]="listMaxHeight" role="listbox" [id]="(testId || 'search-select') + '-listbox'" *ngIf="filteredOptions.length; else emptyTpl" (mousedown)="$event.preventDefault()">
        <li
          *ngFor="let option of filteredOptions; let i = index; trackBy: trackByValue"
          [id]="optionId(option)"
          role="option"
          class="sf-search-select__opt"
          [class.sel]="option.value === value"
          [class.act]="i === activeIndex"
          [class.is-disabled]="option.disabled"
          [attr.aria-selected]="option.value === value"
          (click)="pick(option)"
        >
          <span>{{ option.label }}</span>
          <small *ngIf="option.hint">{{ option.hint }}</small>
        </li>
      </ul>
      <ng-template #emptyTpl>
        <div class="sf-search-select__empty">{{ emptyText }}</div>
      </ng-template>
    </ng-container>

    <div class="sf-search-select__count" *ngIf="!loading">
      {{ filteredOptions.length }} de {{ options.length }} {{ noun }}
    </div>
  </div>
</div>
